import { css } from '@emotion/css'
import Box from '@mui/material/Box'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import DataUnit from '../../../../components/customElements/DataUnit/DataUnit'
import InstallationData from '../../../../components/customElements/RequestDataAccordions/InstallationData'
import OrderHistory from '../../../../components/customElements/RequestDataAccordions/OrderHistory/OrderHistory'
import OrderStatus from '../../../../components/customElements/RequestDataAccordions/OrderStatus'
import UploadedPhotos from '../../../../components/customElements/RequestDataAccordions/UploadedPhotos'
import CustomAccordion from '../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import OrderInfoChips from '../../../../components/OrderInfoChips/OrderInfoChips'
import {
  isAdmin,
  isAdministration,
  isDealer,
  isLooker,
  isOperator,
  isSuperOperator,
} from '../../../../services/AccountService'
import commonStyles from '../../../../styles/commonStyles'
import {
  closeModalFn,
  isModalOpen,
  modalData,
} from '../../../../utils/controllers/ModalController'
import { getStyles } from '../../../../utils/utils/commonUtils'
import { getComp } from '../../../../utils/utils/DI'
import RequestManagementStore from '../../stores/RequestManagementStore'
import { changeOperatorStatusStore } from '../ChangeOperatorStatusDrawer/ChangeOperatorStatusStore'
import AssignToDealerView from '../RequestDetails/AssignToDealerView/AssignToDealerView'
import ChangeStatusView from '../RequestDetails/ChangeStatusView/ChangeStatusView'
import RequestsTableStore from '../RequestsTableOptimized/RequestsTableOptimizedStore'
import DefaultContent from './components/DefaultContent'

function RequestDetailsDrawer({
  filterStore,
  operatorStore,
  ordersStore,
  serviceStore,
  selectReport,
}) {
  const intl = useIntl()
  const classes = getStyles(commonStyles)
  const [store] = useState(
    () => new RequestManagementStore({ operatorStore, ordersStore }),
  )
  const {
    data,
    collection,
    toDefaultView,
    contentState,
    toChangeStatusView,
    setNewEquipment,
  } = store

  const {
    id,
    status,
    isTakenByMe,
    hasDuplicates,
    reportId,
    reportStatus,
    financialSourceId,
    dealer,
    dataCheckingStatus,
    additionalInfo,
    address,
    addressType,
    apartment,
    author,
    authorId,
    authorName,
    building,
    categories,
    created,
    district,
    equipmentId,
    house,
    images,
    installationDate,
    isTaken,
    locality,
    name,
    patronymic,
    phone,
    preferentialCategory,
    priority,
    reason,
    reasonId,
    receiverId,
    sender,
    source,
    surname,
    territory,
  } = data

  const isOrderAvailable = [1, 2, 4, 5, 6, 7, 9, 11].includes(status)
  const [updateHistory, setUpdateHistory] = useState(false)
  const [updateComment, setUpdateComment] = useState(false)
  const { updateOrders, setCurrentClickRow } = RequestsTableStore

  useEffect(() => {
    if (data) {
      updateOrders([data])
    }
  }, [
    id,
    status,
    isTakenByMe,
    hasDuplicates,
    reportId,
    reportStatus,
    financialSourceId,
    dealer,
    dataCheckingStatus,
    additionalInfo,
    address,
    addressType,
    apartment,
    author,
    authorId,
    authorName,
    building,
    categories,
    created,
    district,
    equipmentId,
    house,
    images,
    installationDate,
    isTaken,
    locality,
    name,
    patronymic,
    phone,
    preferentialCategory,
    priority,
    reason,
    reasonId,
    receiverId,
    sender,
    source,
    surname,
    territory,
  ])

  // при закрытии дровера очищаю текущие данные стора
  // иначе при следующем открытии дровера будет лишний запрос со старым id
  useEffect(() => {
    if (!isModalOpen['request-details']) {
      store.clear()
      changeOperatorStatusStore.setUpdateOrderCallback(null)
    } else {
      changeOperatorStatusStore.setUpdateOrderCallback(
        store.setData.bind(store),
      )
    }
  }, [isModalOpen['request-details']])

  useEffect(() => {
    if (
      isAdmin() ||
      (isAdministration() && operatorStore.selectedTab !== 1) ||
      (isOperator() && operatorStore.selectedTab === 1)
    ) {
      if (ordersStore.isLoaded && modalData['request-details'].id) {
        const { id } = modalData['request-details']
        const order = ordersStore.collection.find((el) => el.id === id)
        if (order || modalData['request-details']?.data) {
          if (
            order?.equipmentId ||
            modalData['request-details']?.data?.equipmentId
          ) {
            setNewEquipment(
              operatorStore?.selectedTab === 1 &&
                modalData['request-details']?.data
                ? modalData['request-details']?.data?.equipmentId
                : order?.equipmentId,
            )
          }
          store.setData(
            isOperator() &&
              operatorStore?.selectedTab === 1 &&
              modalData['request-details']?.data
              ? modalData['request-details'].data
              : order,
          )

          store.getImages()
        }
      }
    }
  }, [modalData['request-details'].id, modalData['request-details'].status])

  useEffect(() => {
    if (operatorStore) {
      if (
        isOperator() ||
        (isAdministration() && operatorStore.selectedTab === 1)
      ) {
        if (
          (operatorStore && operatorStore.selectedTab === 0) ||
          (isAdministration() && operatorStore.selectedTab === 1)
        ) {
          const { id } = modalData['request-details']
          const order = operatorStore.collection.find((el) => el.id === id)

          if (order) {
            if (order.equipmentId) {
              setNewEquipment(order.equipmentId)
            }
            store.setData(order)
            store.getImages()
          } else {
            closeModalFn['request-details']()
          }
        }
      }
    }
  }, [operatorStore?.collection, modalData['request-details'].id])

  const closeModals = () => {
    closeModalFn['photo-gallery']()
    closeModalFn['request-details']()
  }

  const statusStore = getComp('StatusesStore')
  const { getStatusName } = statusStore

  const editStatusAdministration = () => {
    return (
      (isAdministration() &&
        (status === 1 ||
          status === 2 ||
          status === 3 ||
          status === 4 ||
          status === 5)) ||
      (status === 11 && operatorStore.selectedTab === 1 && isTakenByMe)
    )
  }

  const showInstallationData =
    isOperator() &&
    ![1, 2, 4, 5].includes(data.status) &&
    operatorStore.selectedTab !== 0

  const showEquipmentId = isSuperOperator() && ![7].includes(data.status)

  return (
    <RightDrawer
      open={isModalOpen['request-details']}
      onClose={closeModals}
      title={
        <>
          <FormattedMessage id={'Заявка'} /> №{String(id).padStart(6, '0')}
        </>
      }
      backButtonClick={contentState === 'default' ? closeModals : toDefaultView}
    >
      <Box className={classNames('fx fx-col')}>
        {contentState === 'default' || contentState === 'changeStatus' ? (
          <Box sx={classes.drawerStatusesInfo}>
            <OrderStatus
              status={status}
              onEdit={
                (isAdmin() && isOrderAvailable) ||
                (isOperator() && isTakenByMe) ||
                editStatusAdministration()
                  ? isLooker()
                    ? null
                    : toChangeStatusView
                  : null
              }
            />
            {status >= 12 &&
            (isAdmin() || isDealer()) &&
            !isLooker() &&
            !serviceStore ? (
              <OrderInfoChips
                tooltip={getStatusName(reportStatus, true)}
                id={reportId} // id отчета
                reportStatus={reportStatus} // статус отчета
                haveChips={true} // регулирует наличие фона по типу чипса
                showOrderStatusIcon={true} // регулирует отображение иконки статуса
              />
            ) : null}
          </Box>
        ) : null}
        {hasDuplicates && (
          <Box
            className={'fx-center'}
            sx={{
              padding: '8px 16px 16px',
              width: '100%',
            }}
          >
            <DataUnit
              value={intl.formatMessage({
                id: 'Отмечена как повторная заявка',
              })}
            />
          </Box>
        )}
        <Box
          name={'content'}
          className={classNames('fx-col jst-sb', css(classes.drawerContent))}
        >
          {contentState === 'default' ? (
            <DefaultContent
              store={store}
              ordersStore={ordersStore}
              operatorStore={operatorStore}
              filterStore={filterStore}
              setUpdateHistory={setUpdateHistory}
              updateHistory={updateHistory}
              updateComment={updateComment}
              setUpdateComment={setUpdateComment}
            />
          ) : null}
          {showInstallationData && (
            <CustomAccordion
              defaultOpenState={data.status === 6}
              onEdit={false}
              summary={intl.formatMessage({ id: 'Данные установки' })}
            >
              {showEquipmentId && (
                <Box mt={2}>
                  <DataUnit
                    name='Id оборудования'
                    value={data.equipmentId || 'Не заполнен'}
                  />
                </Box>
              )}

              <Box mt={2}>
                <DataUnit
                  name='Дата установки'
                  value={
                    moment(data.installationDate).isValid()
                      ? moment(data.installationDate)
                          .startOf('day')
                          .format('DD-MM-YYYY')
                      : 'Не заполнена'
                  }
                />
              </Box>
              <UploadedPhotos
                store={store}
                defaultOpenState={true}
                order={data}
              />
            </CustomAccordion>
          )}
          {contentState === 'assignDealer' ? (
            <AssignToDealerView store={store} />
          ) : null}
          {contentState === 'changeStatus' ? (
            <ChangeStatusView store={store} operatorStore={operatorStore} />
          ) : null}
          {contentState === 'editData' ? (
            <InstallationData
              requestStore={store}
              isEdit={true}
              onEdit={toDefaultView}
              order={data}
              defaultOpenState
              drawerOpen={isModalOpen['request-details']}
              filterStore={filterStore}
              ordersStore={ordersStore}
              operatorStore={operatorStore}
            />
          ) : null}
          {contentState === 'default' && (
            <OrderHistory
              id={id}
              financialSourceId={financialSourceId}
              contentState={contentState}
              updateCondition={updateHistory}
            />
          )}
        </Box>
      </Box>
    </RightDrawer>
  )
}

export default observer(RequestDetailsDrawer)
